import React from 'react';
import { hot } from 'react-hot-loader/root';

import { Home } from './views/Home';

const App: React.FC = () => {
  return <Home />;
};

export default hot(App);
